// 11/02 (Josh): "if a deal is in default, if i was to put it into funded stage, there will be a popup that will say -
// by switching out of default status, because there was collections activity on the deal, everything will be
// removed." Pure view-model for that popup: turns GET /deals/{id}/default-reset-preview into the lines it lists.
// Mirrors routes/deal_default.inventory_summary; tested in defaultResetModel.test.js.

const money = (v) => `$${Number(v || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

const SINGULAR = {
  'lawyer collections': 'lawyer collection',
  'lawyer fees': 'lawyer fee',
  'legal costs / invoices': 'legal cost / invoice',
  'write-offs': 'write-off',
  'in-house recovery payments': 'in-house recovery payment',
};
const singular = (label) => SINGULAR[label] || label;

/**
 * @param {object|null} preview  response of GET /deals/{id}/default-reset-preview
 * @returns {{ hasActivity: boolean, voided: string[], deleted: string[], cleared: string[] }}
 *   voided  — ledger rows that will be voided (stay in the ledger, stop counting)
 *   deleted — records that will be removed outright
 *   cleared — deal fields that go back to blank
 */
export function defaultResetLines(preview) {
  const p = preview || {};
  const voided = [];
  const fee = p.default_fee || {};
  if (fee.count) voided.push(`${plural(fee.count, 'default fee', 'default fees')} (${money(fee.amount)})`);
  for (const a of p.activity || []) {
    voided.push(`${a.count} ${a.count === 1 ? singular(a.label) : a.label} (${money(a.amount)})`);
  }
  const deleted = [];
  if (p.legal_case) {
    const firm = p.legal_case.law_firm_name ? ` with ${p.legal_case.law_firm_name}` : '';
    const st = p.legal_case.case_status ? `, ${p.legal_case.case_status}` : '';
    deleted.push(`the legal case${firm}${st}`);
  }
  if (p.lawyer_collection_records) {
    deleted.push(plural(p.lawyer_collection_records, 'lawyer collection record', 'lawyer collection records'));
  }
  if (p.default_package) deleted.push('the default package (CSV)');
  const cleared = ['default date and default flag'];
  if (p.recovery_status) cleared.push(`recovery status "${p.recovery_status}"`);
  if (p.proposed_settlement) cleared.push('the proposed settlement');
  return { hasActivity: Boolean(p.has_collections_activity), voided, deleted, cleared };
}

/** Headline sentence for the popup. targetStatus null = the Reverse Default button (restores the prior status). */
export function defaultResetHeadline(preview, targetStatus) {
  const target = targetStatus ? `"${targetStatus}"` : 'its pre-default status';
  if (defaultResetLines(preview).hasActivity) {
    return `By switching out of Default to ${target}, because there was collections activity on this deal, everything from the default era will be removed. The deal goes back to its pre-default state so it can be corrected and refilled.`;
  }
  return `By switching out of Default to ${target}, the default fee is removed and the deal goes back to its pre-default state. No collections activity was recorded on this deal.`;
}
